// src/utils/push.js
import { messaging } from "../firebase";
import { getToken } from "firebase/messaging";
import api from "../api";

const VAPID_KEY = "BLipmqpiyGstv-4rFdOJOXo_J7DIO1YSjldhYRHRkSnw-X4dIQ3_WIO38xM3yDXbQQkv0XrlSb5_xz82q0jLQng";


export async function registerPush(apiInstance) {
  try {
    // 호환성 체크
    if (!("Notification" in window)) {
      console.warn("[PUSH] 이 브라우저는 알림을 지원하지 않습니다.");
      return;
    }
    if (!("serviceWorker" in navigator)) {
      console.warn("[PUSH] 이 브라우저는 서비스워커를 지원하지 않습니다.");
      return;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("[PUSH] 알림 권한 거부됨:", permission);
      return;
    }

    // 기존 등록 확인 후 재사용 (중복 등록 방지)
    // ⚠️ getRegistration()은 인자를 "스크립트 URL"이 아니라 "스코프"로 해석한다 —
    // 과거 버전이 루트 스코프에 등록해둔 다른 SW(예: 삭제된 /sw.js)가 있으면 그
    // 등록이 반환돼서, firebase-messaging-sw.js가 영영 등록되지 않고 엉뚱한 SW가
    // 푸시를 처리하게 된다. 그래서 실제 스크립트가 맞는지까지 확인한다.
    const FCM_SW_URL = "/firebase-messaging-sw.js";
    const isFcmSw = (reg) =>
      !!reg && !!(reg.active || reg.installing || reg.waiting) &&
      (reg.active || reg.installing || reg.waiting).scriptURL.endsWith(FCM_SW_URL);

    let registration = await navigator.serviceWorker.getRegistration(FCM_SW_URL);
    if (!isFcmSw(registration)) {
      // 스코프를 점유한 낡은 SW는 정리하고(있다면) 올바른 SW로 다시 등록
      if (registration) {
        await registration.unregister().catch(() => {});
      }
      registration = await navigator.serviceWorker.register(FCM_SW_URL);
    }
    await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });


    if (token) {
      await apiInstance.post("/tasks/push/subscribe/", {
        endpoint: token,
        keys: { p256dh: "", auth: "" },
      });
      console.log("✅ FCM 토큰 저장 완료:", token);
    } else {
      console.warn("[PUSH] 토큰 발급 실패 (권한 또는 VAPID 문제 가능)");
    }
  } catch (e) {
    console.error("[PUSH] 등록 실패:", e);
  }
}